import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
const firebaseConfig = {
  apiKey: "AIzaSyDZSU7W47CwpFXdlWQj4Yz3NX8zWZ0X0Q8",
  authDomain: "kaustuis.firebaseapp.com",
  databaseURL:
    "https://kaustuis-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "kaustuis",
  storageBucket: "kaustuis.appspot.com",
  messagingSenderId: "848677823145",
  appId: "1:848677823145:web:1e220bdc6234ec83047fb8",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const db = getFirestore(app);
export const database = getDatabase(app);
